import { render, staticRenderFns } from "./templateAge.vue?vue&type=template&id=a1d0692c&scoped=true"
import script from "./templateAge.vue?vue&type=script&lang=js"
export * from "./templateAge.vue?vue&type=script&lang=js"
import style0 from "./templateAge.vue?vue&type=style&index=0&id=a1d0692c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d0692c",
  null
  
)

export default component.exports